<template>
    <section class="odocs-spaced">
        <p>
            <o-button label="Default" outlined />
            <o-button label="Primary" variant="primary" outlined />
            <o-button label="Secondary" variant="secondary" outlined />
            <o-button label="Success" variant="success" outlined />
            <o-button label="Info" variant="info" outlined />
            <o-button label="Warning" variant="warning" outlined />
            <o-button label="Danger" variant="danger" outlined />
        </p>
    </section>
</template>
